import { ComponentProps } from 'react';
import { FieldPath, FieldValues } from 'react-hook-form';

import { DatePicker } from '@/components/core/date-picker';

import { DefaultFormField, FormFieldProps } from './default-form-field';

export function DatePickerFormField<
  TFieldValues extends FieldValues,
  TName extends FieldPath<TFieldValues>,
>({
  control,
  name,
  disabled,
  label,
  description,
  hideError,
  ...props
}: FormFieldProps<ComponentProps<typeof DatePicker>, TFieldValues, TName>) {
  return (
    <DefaultFormField
      control={control}
      name={name}
      label={label}
      description={description}
      hideError={hideError}
      disabled={disabled}
      render={({ field }) => (
        <DatePicker
          {...props}
          selected={field.value ?? undefined}
          onSelect={field.onChange}
          disabled={disabled}
        />
      )}
    />
  );
}
